import { each, go } from 'fxjs/es';
import { $findAll, $setHTML } from 'fxdom/es';

export const setTitle = ({ el, title }) => go(el, $findAll(`.header .title`), each($setHTML(title)));

export const setPrice = ({ el, price }) => go(el, $findAll(`.header .price`), each($setHTML(price)));
